import { MonochromeLink } from '@liveauctioneers/hammer-ui-core/link';
import { H4 } from '@liveauctioneers/hammer-ui-core/text';

import { CatalogMapPoint } from '@/redux/modules/auctionsNearMe/catalogsNearMe.types';

type Props = {
    catalogId: number;
    pointsByLocation: Record<string, CatalogMapPoint[]>;
    selectedPoint: CatalogMapPoint;
};

export const InfoWindowContent = ({ pointsByLocation, selectedPoint }: Props) => {
    const pointsAtLocation = pointsByLocation[`${selectedPoint.lat},${selectedPoint.lng}`] ?? [selectedPoint];

    return (
        <article className="flex flex-col gap-3xs p-2xs">
            <header>
                <H4>{selectedPoint.houseName}</H4>
            </header>
            <section className="flex flex-col gap-2xs">
                {pointsAtLocation.map((point) => (
                    <div key={point.catalogId}>
                        <MonochromeLink
                            href={`/catalog/${point.catalogId}`}
                            size="xs"
                            target="_blank"
                        >
                            {point.catalogTitle}
                        </MonochromeLink>
                    </div>
                ))}
            </section>
        </article>
    );
};
